<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<div v-if="xiazai" style="background: #00fff0;padding: 4px 0;width: 130px; margin-bottom: 10px; text-align: center;cursor: pointer; " @click="xiazaia">Sailing Report</div>
			<li>
				<span>108、Continuous working time of inspector (Non-must fill)(For example: and subsequently dates on 13th, 14th, 15th, 16th, 17th, 18th, 19th, 20th,April 2020）
				<p style="color: #fff;"> and subsequently dates on</p>
				</span>
				<span>{{ dataList.jz108 }}</span>
			</li>
			<li>
				<span>109、Name of the consignor/clients(For example:VS TRADING SA.）
				</span>
				<span>{{ dataList.jz109 }}</span>
			</li>
			<li>
				<span>110、The time of inspector onboardFor example:1900hrs on 13-Apr-2020
				</span>
				<span>{{ dataList.jz110 }}</span>
			</li>
			<li>
				<span>111、Hatch cover type of cargo hold(For example:hydraulic folding type hatch）
				</span>
				<span>{{ dataList.jz111 }}</span>
			</li>
			<li>
				<span>112、Which number of this loading port(For example: first）
				</span>
				<span>{{ dataList.jz112 }}</span>
			</li>
			<li>
				<span>113、Next port the vessel sailing to(For example: Tianjin port）
				</span>
				<span>{{ dataList.jz113 }}</span>
			</li>
			<li>
				<span>114、No accident/Obvious damage
				</span>
				<span>{{ dataList.jz114 }}</span>
			</li>



			<li>
				<span>115、Mate's Receipt</span>
				<div class="imgs" v-if="dataList.jz115">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz115.split('|')" />
				</div>
			</li>
			<li>
				<span>116、 P&I Surveyor's Report</span>
				<div class="imgs" v-if="dataList.jz116">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz116.split('|')" />
				</div>
			</li>
			<li>
				<span>117、 P&I Surveyor's Report</span>
				<div class="imgs" v-if="dataList.jz117">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz117.split('|')" />
				</div>
			</li>
			<li>
				<span>118、Tally certificates</span>
				<div class="imgs" v-if="dataList.jz118">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz118.split('|')" />
				</div>
			</li>
			<li>
				<span>119、Ship's particulars</span>
				<div class="imgs" v-if="dataList.jz119">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz119.split('|')" />
				</div>
			</li>
			<li>
				<span>120、Photoes of Vessel's condition before shipment</span>
				<div class="imgs" v-if="dataList.jz120">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz120.split('|')" />
				</div>
			</li>
			<li>
				<span>125、Photo of the cargo condition before loading</span>
				<div class="imgs" v-if="dataList.jz125">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz125.split('|')" />
				</div>
			</li>
			<li>
				<span>126、Photoes of loading operation</span>
				<div class="imgs" v-if="dataList.jz126">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz126.split('|')" />
				</div>
			</li>
			<li>
				<span>127、Photoes of dunnage</span>
				<div class="imgs" v-if="dataList.jz127">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz127.split('|')" />
				</div>
			</li>
			<li>
				<span>130、Photoes of lashing</span>
				<div class="imgs" v-if="dataList.jz130">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz130.split('|')" />
				</div>
			</li>
			<li>
				<span>128、Cargo stowage condition in cargo hold</span>
				<div class="imgs" v-if="dataList.jz128">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz128.split('|')" />
				</div>
			</li>
			<li>
				<span>121、Signature of inspector</span>
				<div class="imgs" v-if="dataList.jz121">
					<img style="background: #fff;" :src="item" v-for="(item, index) in dataList.jz121.split('|')" />
				</div>
			</li>
			<li>
				<span>122、Date </span>
				<span>{{dataList.jz122}}</span>
			</li>


		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'ly',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: '',
			kid:'',
			xiazai:false
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.xiazai = this.$route.query.xiazai;
			this.getSchedulely();
		}
	},
	methods: {
		xiazaia(){
			window.open('http://39.105.212.82/userfiles/null/fj/reportImg/' + this.kid + '.pdf')
		},
		getSchedulely() {
			let data = {
				id: this.id
			};
			this.$api.zb(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
					this.kid=res.data.id
					// if (res.data.ly026) {
					// 	if (this.getSuffix(res.data.ly026) == 'pdf') {
					// 		this.num = 1;
					// 	} else {
					// 		this.num = 0;
					// 	}
					// }
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
